var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-edit" },
    [
      _c("div", { staticClass: "edit-grid" }, [
        _c("div", { staticClass: "a-card edit-main" }, [
          _c("div", { staticClass: "a-toolbar" }, [
            _c("strong", { staticStyle: { "font-size": "13.5px" } }, [
              _vm._v(
                _vm._s(_vm.form.id ? "编辑页面 #" + _vm.form.id : "新建页面")
              ),
            ]),
            _c("span", { staticClass: "grow" }),
            _vm.savedAt
              ? _c("span", { staticClass: "save-hint" }, [
                  _vm._v("已保存 " + _vm._s(_vm.savedAt)),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "edit-form" }, [
            _c("div", { staticClass: "a-form-row" }, [
              _vm._m(0),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.title,
                    expression: "form.title",
                  },
                ],
                staticClass: "a-input",
                attrs: { placeholder: "例如：入目无他人，四下皆是你" },
                domProps: { value: _vm.form.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "title", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "row-2" }, [
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [
                  _vm._v(" 路由标识 "),
                  _c("span", { staticClass: "f-tip" }, [
                    _vm._v("前台地址 #/p/" + _vm._s(_vm.form.code || "xxx")),
                  ]),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.code,
                      expression: "form.code",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "留空自动生成，如 we / last" },
                  domProps: { value: _vm.form.code },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "code", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [_vm._v("渲染主题")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.theme,
                        expression: "form.theme",
                      },
                    ],
                    staticClass: "a-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "theme",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.themes, function (t) {
                    return _c(
                      "option",
                      { key: t.value, domProps: { value: t.value } },
                      [_vm._v(_vm._s(t.label))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _c("div", { staticClass: "row-2" }, [
              _c("div", { staticClass: "a-form-row" }, [
                _vm._m(1),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.subtitle,
                      expression: "form.subtitle",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "可留空" },
                  domProps: { value: _vm.form.subtitle },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "subtitle", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _vm._m(2),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.nameText,
                      expression: "form.nameText",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "例如：小 张 玲" },
                  domProps: { value: _vm.form.nameText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "nameText", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "a-form-row" }, [
              _vm._m(3),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.summary,
                    expression: "form.summary",
                  },
                ],
                staticClass: "a-input",
                attrs: { placeholder: "一两句话介绍这封信" },
                domProps: { value: _vm.form.summary },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "summary", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "row-2" }, [
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [_vm._v("列表角标")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tag,
                      expression: "form.tag",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "例如：🌹 红玫瑰" },
                  domProps: { value: _vm.form.tag },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "tag", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _vm._m(4),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.date,
                      expression: "form.date",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "例如：2026年3月1日" },
                  domProps: { value: _vm.form.date },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "date", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "a-form-row" }, [
              _vm._m(5),
              _c(
                "div",
                { staticClass: "list-editor" },
                [
                  _vm._l(_vm.form.verses, function (v, i) {
                    return _c("div", { key: "v" + i, staticClass: "le-item" }, [
                      _c("span", { staticClass: "le-idx" }, [
                        _vm._v(_vm._s(i + 1)),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.verses[i],
                            expression: "form.verses[i]",
                          },
                        ],
                        staticClass: "a-input",
                        attrs: {
                          placeholder: "例：只愿君心似我心，定不负相思意。",
                        },
                        domProps: { value: _vm.form.verses[i] },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form.verses, i, $event.target.value)
                          },
                        },
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "a-btn mini danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeItem(_vm.form.verses, i)
                            },
                          },
                        },
                        [_vm._v("×")]
                      ),
                    ])
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "a-btn mini",
                      on: {
                        click: function ($event) {
                          return _vm.form.verses.push("")
                        },
                      },
                    },
                    [_vm._v("＋ 加一句")]
                  ),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "a-form-row" }, [
              _vm._m(6),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.verseFrom,
                    expression: "form.verseFrom",
                  },
                ],
                staticClass: "a-input",
                attrs: { placeholder: "例如：李之仪《卜算子》" },
                domProps: { value: _vm.form.verseFrom },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "verseFrom", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "a-form-row" }, [
              _c("label", { staticClass: "f-label" }, [
                _vm._v(" 正文段落 "),
                _c("span", { staticClass: "f-tip" }, [
                  _vm._v(
                    "共 " + _vm._s(_vm.paraCount) + " 段 · 每段一个输入框"
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "list-editor" },
                [
                  _vm._l(_vm.form.paragraphs, function (p, i) {
                    return _c(
                      "div",
                      { key: "p" + i, staticClass: "le-item para" },
                      [
                        _c("span", { staticClass: "le-idx" }, [
                          _vm._v(_vm._s(i + 1)),
                        ]),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.paragraphs[i],
                              expression: "form.paragraphs[i]",
                            },
                          ],
                          staticClass: "a-input",
                          attrs: { placeholder: "这一段想说的话…" },
                          domProps: { value: _vm.form.paragraphs[i] },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form.paragraphs,
                                i,
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c("div", { staticClass: "le-ops" }, [
                          _c(
                            "button",
                            {
                              staticClass: "a-btn mini",
                              attrs: { disabled: i === 0 },
                              on: {
                                click: function ($event) {
                                  return _vm.move(_vm.form.paragraphs, i, -1)
                                },
                              },
                            },
                            [_vm._v("↑")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "a-btn mini",
                              attrs: {
                                disabled: i === _vm.form.paragraphs.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.move(_vm.form.paragraphs, i, 1)
                                },
                              },
                            },
                            [_vm._v("↓")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "a-btn mini danger",
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(_vm.form.paragraphs, i)
                                },
                              },
                            },
                            [_vm._v("×")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "a-btn mini",
                      on: {
                        click: function ($event) {
                          return _vm.form.paragraphs.push("")
                        },
                      },
                    },
                    [_vm._v("＋ 加一段")]
                  ),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "row-2" }, [
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [_vm._v("落款署名")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.sign,
                      expression: "form.sign",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "例如：大大大混蛋-----玲" },
                  domProps: { value: _vm.form.sign },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "sign", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [_vm._v("落款日期")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.signDate,
                      expression: "form.signDate",
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { placeholder: "例如：2026年3月10日" },
                  domProps: { value: _vm.form.signDate },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "signDate", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "row-3" }, [
              _c("div", { staticClass: "a-form-row" }, [
                _c("label", { staticClass: "f-label" }, [_vm._v("状态")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.form.status,
                        expression: "form.status",
                        modifiers: { number: true },
                      },
                    ],
                    staticClass: "a-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.$set(
                          _vm.form,
                          "status",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("草稿（前台不可见）"),
                    ]),
                    _c("option", { domProps: { value: 1 } }, [
                      _vm._v("已发布"),
                    ]),
                    _c("option", { domProps: { value: 2 } }, [
                      _vm._v("已下线"),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _vm._m(7),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.form.sort,
                      expression: "form.sort",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "a-input",
                  attrs: { type: "number" },
                  domProps: { value: _vm.form.sort },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "sort", _vm._n($event.target.value))
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "a-form-row" }, [
                _vm._m(8),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.remark,
                      expression: "form.remark",
                    },
                  ],
                  staticClass: "a-input",
                  domProps: { value: _vm.form.remark },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "remark", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "edit-actions" }, [
              _c(
                "button",
                {
                  staticClass: "a-btn primary",
                  attrs: { disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.save(false)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.saving ? "保存中…" : "保存") + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "a-btn primary",
                  attrs: { disabled: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.save(true)
                    },
                  },
                },
                [_vm._v(" 保存并发布 ")]
              ),
              _c("button", { staticClass: "a-btn", on: { click: _vm.back } }, [
                _vm._v("返回列表"),
              ]),
              _c("span", { staticClass: "grow" }),
              _c(
                "button",
                {
                  staticClass: "a-btn",
                  attrs: { disabled: !_vm.form.id },
                  on: { click: _vm.preview },
                },
                [_vm._v("预览效果")]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "a-card edit-side" }, [
          _vm._m(9),
          _c(
            "div",
            { staticClass: "mini-preview", class: _vm.form.theme },
            [
              _vm.form.nameText
                ? _c("div", { staticClass: "mp-name" }, [
                    _vm._v(_vm._s(_vm.form.nameText)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "mp-title" }, [
                _vm._v(_vm._s(_vm.form.title || "（页面标题）")),
              ]),
              _vm.form.subtitle
                ? _c("div", { staticClass: "mp-sub" }, [
                    _vm._v(_vm._s(_vm.form.subtitle)),
                  ])
                : _vm._e(),
              _vm.form.date
                ? _c("div", { staticClass: "mp-date" }, [
                    _vm._v(_vm._s(_vm.form.date)),
                  ])
                : _vm._e(),
              _vm._l(_vm.verseList, function (v, i) {
                return _c("div", { key: "mv" + i, staticClass: "mp-verse" }, [
                  _vm._v(_vm._s(v)),
                ])
              }),
              _vm._l(_vm.paraList, function (p, i) {
                return _c("div", { key: "mp" + i, staticClass: "mp-para" }, [
                  _vm._v(_vm._s(p)),
                ])
              }),
              _vm.form.sign
                ? _c("div", { staticClass: "mp-sign" }, [
                    _vm._v(_vm._s(_vm.form.sign)),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "mp-count" }, [
                _vm._v("正文 " + _vm._s(_vm.paraCount) + " 段"),
              ]),
            ],
            2
          ),
        ]),
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.toast
          ? _c("div", { staticClass: "a-toast", class: _vm.toast.type }, [
              _vm._v(_vm._s(_vm.toast.text)),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("页面标题"),
      _c("span", { staticClass: "req" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("副标题"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("信头/标题下方的小字")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("主体称谓"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("红玫瑰主题正中显示")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("列表摘要"),
      _c("span", { staticClass: "f-tip" }, [
        _vm._v("显示在「信箱」列表卡片上"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("页面日期"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("信头显示的日期")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v(" 诗句 "),
      _c("span", { staticClass: "f-tip" }, [
        _vm._v("每行一句，红玫瑰主题会逐句居中展示"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("诗句出处"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("集句时标注，可留空")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("排序"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("越大越靠前")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "f-label" }, [
      _vm._v("备注"),
      _c("span", { staticClass: "f-tip" }, [_vm._v("仅后台可见")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "a-toolbar" }, [
      _c("strong", { staticStyle: { "font-size": "13.5px" } }, [
        _vm._v("实时速览"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }